import Vue from 'vue'
import './plugins/vuetify'
import App from './App.vue'
import router from './router'
import store from './store'
import Axios from 'axios'
import vueSignature from 'vue-signature'

import 'material-design-icons-iconfont/dist/material-design-icons.css'
import './registerServiceWorker'

Vue.config.productionTip = false

Vue.use({
  iconfont: 'fa',
})

Vue.use(vueSignature)

Vue.prototype.$http = Axios
const token = localStorage.getItem('token')
if (token === 'undefined') {
  localStorage.removeItem('token')
}
if (token) {
  Vue.prototype.$http.defaults.headers.common['Authorization'] = token
}

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
